<template>
<div class="chapter">
<div class="inner_page">
<div>
<a id="dedi"></a>
</div>
<p class="dedication"><strong>Dedicated To</strong></p>
<p class="center"> </p>
<div class="top">
<p class="center">First Responders who performed their duty and paid the highest price—Each of whom, trapped by circumstances, met his or her destiny;</p>
</div>
<p class="center">Surviving families adjusting to their new normality;</p>
<p class="center">All who made it out;</p>
<p class="center">Those who kept me sane and balanced throughout the difficult years;</p>
<p class="center">And all of my absent friends and colleagues, especially Douglas G. Karpiloff &amp; Sarah K. Ronningen.</p>
<p class="center"> </p>
<div class="top">
<p class="center">With Love and Gratitude</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_dedi.vue?b64d624c